<script>
export default {
  name: 'EventPositionPrizeMoney',
  props: {
    positionNo: {
      type: String,
      required: true,
    },
    prizeMoney: {
      type: Number,
      required: true,
    },
    placeWinners: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    positionPlaceClass() {
      const { positionNo, placeWinners } = this;
      if (positionNo == 1) return 'win';
      if (positionNo > 1 && positionNo <= placeWinners) return 'place';
      return '';
    },
  },
};
</script>

<template>
  <div class="event-pos-prize-money">
    <div class="event-pos-prize-money__container">
      <div class="event-pos-prize-money__left">
        <div :class="`event-pos-prize-money__position ${positionPlaceClass}`">
          <p>{{ positionNo }}</p>
        </div>
      </div>
      <div class="event-pos-prize-money__right">
        <div class="event-pos-prize-money__pos">{{ positionNo | numberOrdinal }}</div>
        <div class="event-pos-prize-money__prize-money">${{ prizeMoney }}</div>
      </div>
    </div>
  </div>
</template>
